import {Dimensions} from './dimensions'
import type {PaperOrientation} from './paperOrientation'
import type {PaperSize} from './paperSize'
import type {Size} from './size'

const defaultPageWidthInDocumentPoints = 610
const reflowInsetsInInches = {left: 1, right: 1, top: 1, bottom: 1}

const legacyPageWidthInDocumentPoints = 768.0
const legacyMarginWidthInDocumentPoints = 20.0

export const marginToPageRatio = legacyMarginWidthInDocumentPoints / legacyPageWidthInDocumentPoints
export const defaultPageSizeInDocumentPoints = {
  width: defaultPageWidthInDocumentPoints,
  height: defaultPageWidthInDocumentPoints * (11 / 8.5)
}

export namespace NotePageSize {
  // Logic adapted from NotePageSize.swift
  export function pageSizeInDocumentPoints(
    paperSize: PaperSize,
    paperSizingBehavior: string,
    paperOrientation: PaperOrientation
  ): Size {
    const paperDimensions = Dimensions.forPaperSize(paperSize)
    const paperDimensionsInInches = Dimensions.convert(paperDimensions, 'inches')
    if (paperSizingBehavior.startsWith('lockedWidth')) {
      const stringComponents = paperSizingBehavior.split(':')
      const lockedCanvasWidth = +(stringComponents[1] ?? defaultPageWidthInDocumentPoints)

      const printWidthInInches = paperDimensionsInInches.width

      const reflowContentWidthInPoints = lockedCanvasWidth - 2 * lockedCanvasWidth * marginToPageRatio
      const reflowContentWidthInInches = printWidthInInches - reflowInsetsInInches.left - reflowInsetsInInches.right

      const reflowPointsPerInch = reflowContentWidthInPoints / reflowContentWidthInInches

      const reflowContentHeightInInches =
        paperDimensionsInInches.height - reflowInsetsInInches.top - reflowInsetsInInches.bottom
      const reflowContentHeightInDocumentPoints = reflowContentHeightInInches * reflowPointsPerInch

      return {width: lockedCanvasWidth, height: reflowContentHeightInDocumentPoints}
    } else {
      const standardWidthInInches = Dimensions.forPaperSize('letter').size.width
      const scaleFactor =
        (paperOrientation === 'portrait' ? paperDimensionsInInches.width : paperDimensionsInInches.height) /
        standardWidthInInches
      const canvasWidth = defaultPageWidthInDocumentPoints * scaleFactor
      const ratio = paperDimensionsInInches.height / paperDimensionsInInches.width
      const pageHeight = paperOrientation === 'portrait' ? canvasWidth * ratio : canvasWidth / ratio

      return {width: canvasWidth, height: pageHeight}
    }
  }

  export function marginWidth(pageWidth: number) {
    return pageWidth * marginToPageRatio
  }

  export function defaultYOffsetForPage(pageNumber: number, pageHeight: number) {
    return pageNumber * pageHeight
  }
}
